import { Card, Image, Button } from "@aws-amplify/ui-react"
import SmartSelect from "./smart-select"
import { useState } from "react"
import { shallowEqual, useSelector } from "react-redux"
import { Modal } from "react-bootstrap"

export const CatalogItemCard = ({ item, onAddExercise }) => {

    const [day, setDay] = useState("Day 1")
    const existingDays = useSelector((state) => {
        const dbDays = state?.exercises?.items?.map(value => value.day) || [];
        const defaultDays = ["Day 1", "Day 2", "Day 3"];
        return [...new Set([...dbDays, ...defaultDays])];
    }, shallowEqual
    )
    const [oeprationInProgress, setOperationInProgress] = useState(false)
    const [modalShow, setModalShow] = useState(false);
    const [currentItem, setCurrentItem] = useState(null)
    return (
        <>
            <Card className="text-align-start h-100 shadow-4">
                <div className="row">
                    <div className="col-3">
                        <Image
                            src={item.picture}
                            objectFit="cover"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setModalShow(true)
                                setCurrentItem(item)
                            }}
                            objectPosition="50% 50%"
                            backgroundColor="initial"
                            height="98%"
                            width="98%"
                            opacity="100%"
                        />
                    </div>
                    <div className="col-9">
                        <div className="d-flex flex-column justify-content-between h-100">
                            <div>
                                <h4>{item.name}</h4>
                                <p className="justified">{item.description}</p>
                            </div>
                            <div className="d-flex align-items-top">
                                <div style={{ maxWidth: '15rem' }} className="me-2">
                                    <SmartSelect
                                        value={day}
                                        label="Day"
                                        style={{ maxWidth: '10rem' }}
                                        minLength={1}
                                        onValueChanged={(e) => {
                                            setDay(e)
                                        }} >
                                        {
                                            existingDays.map((value, index) => <option value={value} key={index}></option>)
                                        }

                                    </SmartSelect>
                                </div>
                                <Button
                                    className="mt-2"
                                    disabled={oeprationInProgress}
                                    isLoading={oeprationInProgress}
                                    loadingText="In process"
                                    onClick={async () => {
                                        setOperationInProgress(true)
                                        await onAddExercise(day)
                                        setOperationInProgress(false)
                                    }}
                                    style={{ height: '56px' }}>
                                    Add to Workout
                                </Button>

                            </div>
                        </div>
                    </div>
                </div>

            </Card>

            <Modal

                show={modalShow}
                onHide={() => {
                    setModalShow(false)
                    setCurrentItem(null)
                }}
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {currentItem?.name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-align-center">
                    {currentItem &&
                        <Image
                            src={currentItem.picture}

                        />
                    }
                </Modal.Body>

            </Modal>

        </>
    )
}